import { JavaAPI, JAVA_SERVICE_ENDPOINTS } from '@buildwise/libs/services';
import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { ConfigType } from 'config/config';

export type ConfigResponseType = { config?: ConfigType; configs?: ConfigType[] };

class MyHubAPI extends JavaAPI {
  public getMyTasks({
    companyId,
    articleType,
    username,
  }: {
    companyId: string;
    articleType: ArticleSourceType;
    username: string;
  }) {
    return this.get(
      JAVA_SERVICE_ENDPOINTS.GET_MY_TASKS.replace(':companyId', companyId)
        .replace(':username', username)
        .replace(':articleType', articleType),
    );
  }

  public getUnassignedSuggestions({ companyId }: { companyId: string }) {
    return this.get(
      JAVA_SERVICE_ENDPOINTS.GET_UNASSIGNED_SUGGESTIONS.replace(':companyId', companyId),
    );
  }
}

const myHubAPI = new MyHubAPI();
export default myHubAPI;
